import localForage from "localforage";

const DB_NAME = "WoneCompanyDB";

enum WONE_DB_KEYS {
  MEMBERS_PAGINATION_NUMBER = "membersPaginationPage",
  MEMBERS_TOTAL_PAGES = "membersTotalPages",
}

const membersDB = localForage.createInstance({
  name: DB_NAME,
  driver: [localForage.INDEXEDDB, localForage.WEBSQL, localForage.LOCALSTORAGE],
  version: 1.0,
  storeName: "members",
});

export { membersDB, WONE_DB_KEYS };
